import { createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "menu-item px-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }, " Periodos ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_4 = { class: "menu-item px-3" }
const _hoisted_5 = { class: "menu-item px-3" }
const _hoisted_6 = { class: "menu-item px-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("a", _mergeProps({
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh(1,5)))
      }, { period: '120' }, { class: "menu-link px-3" }), " Última hora. ", 16)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("a", _mergeProps({
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refresh(24,15)))
      }, { period: '1440' }, { class: "menu-link px-3" }), " Últimas 24 horas. ", 16)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("a", _mergeProps({
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refresh(168,60)))
      }, { period: '1440' }, { class: "menu-link px-3" }), " Últimos 7 días. ", 16)
    ]),
    _hoisted_7
  ]))
}